import * as React from 'react'

/**
 * Reducer function
 */
const authReducer = (state, action) => {
  switch (action.type) {
    case 'LOGIN':
      localStorage.setItem('user', JSON.stringify(action.payload))
      return { user: action.payload }

    case 'LOGOUT':
      localStorage.removeItem('user')
      return { user: null }

    default:
      return state
  }
}

/**
 * Creating context
 */
export const AuthContext = React.createContext()

/**
 * Context provider component
 */
export const AuthProvider = ({ children }) => {
  const [state, dispatch] = React.useReducer(authReducer, { user: JSON.parse(localStorage.getItem('user')) })

  return (
    <AuthContext.Provider value={{ ...state, dispatch }}>
      {children}
    </AuthContext.Provider>
  )
}
